import "../cssforcomponents/myloader.css";
export const Myloader = () => (
  <center>
    <span className="myloader"></span>
  </center>
);
